import React, { useState, useEffect } from 'react';
import { Modal, Button, Table, Badge } from 'react-bootstrap';
import { obtenerSubNews, agregarSubNews, actualizarSubNews, eliminarSubNews, archivarSubNews, restaurarSubNews } from '../AccionesBackend';
import FormularioSubNews from './FormularioSubNews';
import Swal from "sweetalert2";

const AdminSubNews = () => {
  const [subnews, setSubnews] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [subnewsSeleccionada, setSubnewsSeleccionada] = useState(null);
  const [error, setError] = useState(null);

  const refrescarSubNews = async () => {
    try {
      const response = await obtenerSubNews();
      if (response && response.status === "OK") {
        setSubnews(response.subnews);
        setError(null);
      } else {
        setError("No se encontraron subnews.");
      }
    } catch (err) {
      console.error("Error al obtener subnews:", err);
      setError("Error al obtener subnews.");
    }
  };

  useEffect(() => {
    refrescarSubNews();
  }, []);

  const handleAgregarSubNews = () => {
    // Para agregar, podemos permitir agregar varios subnews a la vez.
    // Por ejemplo, dejamos subnewsSeleccionada en null para abrir el formulario vacío.
    setSubnewsSeleccionada(null);
    setModalShow(true);
  };

  const handleEditarSubNews = (subnewsItem) => {
    setSubnewsSeleccionada(subnewsItem);
    setModalShow(true);
  };

  // Si deseas permitir agregar múltiples subnews a la vez, podrías diseñar el formulario
  // para que maneje un array de subnews.
  // Por simplicidad, a continuación se muestra la versión para agregar o editar un solo registro.
  const handleGuardarSubNews = async (formData) => {
    try {
      const rol_id = localStorage.getItem("usuarioId") || localStorage.getItem("rol_id") || "0";
      const seccion = 27;
      
      const data = new FormData();
      data.append("title", formData.title || "");
      data.append("content", formData.content || "");
      data.append("rol_id", rol_id);
      data.append("seccion", seccion);
  
      if (formData.image && formData.image instanceof File) {
        data.append("image", formData.image);
      }
  
      let response;
      if (subnewsSeleccionada) {
        data.append("id", subnewsSeleccionada.id);
        response = await actualizarSubNews(Object.fromEntries(data));
      } else {
        response = await agregarSubNews(data);
      }
  
      if (response && response.status === "OK") {
        setModalShow(false);
        setSubnewsSeleccionada(null);
        refrescarSubNews();
        Swal.fire({ icon: "success", title: "Subnoticia", text: "Guardado correctamente.", timer: 1500, showConfirmButton: false });
      } else {
        const msg = response?.result?.error_msg || response?.mensaje || "Error al guardar la Subnoticia.";
        Swal.fire({icon: "error", title: "Error", text: msg});
      }
    } catch (error) {
      console.error("Error al guardar la subnews:", error);
      Swal.fire({icon: "error", title: "Error", text: "Error de conexión al guardar la Subnoticia."});
    }
  };

  const handleArchivarSubNews = async (item) => {
    const esActiva = parseInt(item.activo) === 1;
    const textoAccion = esActiva ? 'archivar (ocultar)' : 'restaurar (mostrar)';

    const confirmacion = await Swal.fire({
      icon: 'question',
      title: `¿Deseas ${textoAccion} esta subnoticia?`,
      text: esActiva
        ? 'La subnoticia se ocultará pero no se eliminará. Podrás restaurarla después.'
        : 'La subnoticia volverá a ser visible para los usuarios.',
      showCancelButton: true,
      confirmButtonText: esActiva ? 'Sí, archivar' : 'Sí, restaurar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: esActiva ? '#f39c12' : '#27ae60',
    });
    if (!confirmacion.isConfirmed) return;

    try {
      const response = esActiva
        ? await archivarSubNews(item.id)
        : await restaurarSubNews(item.id);

      if (response && response.status === 'OK') {
        Swal.fire({ icon: 'success', title: esActiva ? 'Archivada' : 'Restaurada', text: response.mensaje, timer: 1800, showConfirmButton: false });
        refrescarSubNews();
      } else {
        Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo completar la acción.' });
      }
    } catch (error) {
      console.error('Error al archivar/restaurar:', error);
      Swal.fire({ icon: 'error', title: 'Error', text: 'Error de conexión.' });
    }
  };

  const handleEliminarSubNews = async (id) => {
    const confirmacion = await Swal.fire({
      icon: 'warning',
      title: '¿Eliminar Subnoticia?',
      text: 'Esta acción no se puede deshacer.',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    });
    if (!confirmacion.isConfirmed) return;

    try {
      const response = await eliminarSubNews(id);
      if (response && response.status === "OK") {
        Swal.fire({ icon: "success", title: "Eliminado", text: "Subnoticia eliminada.", timer: 1500, showConfirmButton: false });
        refrescarSubNews();
      } else {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    } catch (error) {
      console.error("Error al eliminar:", error);
      Swal.fire({ icon: "error", title: "Error", text: "Error al eliminar." });
    }
  };
  
  return (
    <div>
      <h1>Administrar Subnoticia</h1>
      <Button variant="success" onClick={handleAgregarSubNews}>
        Agregar Subnoticia
      </Button>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <Table striped bordered hover className="mt-3">
        <thead>
          <tr>
            <th>Título</th>
            <th>Content</th>
            <th>Imagen</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {subnews.map((item) => (
            <tr key={item.id} style={{ opacity: parseInt(item.activo) === 1 ? 1 : 0.55 }}>
              <td>{item.title}</td>
              <td>{item.content}</td>
              <td>
              {item.image ? (
                    <img src={item.image} alt={item.title} style={{ width: "100px", height:"100px"}} />
                ) : (
                    "Sin imagen"
                )}
              </td>
              <td>
                {parseInt(item.activo) === 1
                  ? <Badge bg="success">Activa</Badge>
                  : <Badge bg="secondary">Archivada</Badge>}
              </td>
              <td style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                <Button size="sm" variant="primary" onClick={() => handleEditarSubNews(item)}>
                  Editar
                </Button>
                <Button
                  size="sm"
                  variant={parseInt(item.activo) === 1 ? 'warning' : 'success'}
                  onClick={() => handleArchivarSubNews(item)}
                >
                  {parseInt(item.activo) === 1 ? '📂 Archivar' : '♻️ Restaurar'}
                </Button>
                <Button size="sm" variant="danger" onClick={() => handleEliminarSubNews(item.id)}>
                  Eliminar
                </Button>
              </td>
            </tr>
          ))}

        </tbody>
      </Table>
      <Modal show={modalShow} onHide={() => { setModalShow(false); setSubnewsSeleccionada(null); }} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{subnewsSeleccionada ? "Editar Subnoticia" : "Agregar Subnoticia"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormularioSubNews
            subnewsSeleccionada={subnewsSeleccionada}
            onGuardar={handleGuardarSubNews}
            onCancelar={() => { setModalShow(false); setSubnewsSeleccionada(null); }}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AdminSubNews;
